import fileHandles from './fileHandles';

export const COMPLETE_STEP = 'fileUpload/COMPLETE_STEP';
export const SET_COPYRIGHT_FILE = 'fileUpload/SET_COPYRIGHT_FILE';
export const SET_DISSERTATION_FILE = 'fileUpload/SET_DISSERTATION_FILE';

export const setCopyrightFile = file => {
  fileHandles.copyright = file;

  return {
    type: SET_COPYRIGHT_FILE,
    file,
  };
};

export const setDissertationFile = file => {
  fileHandles.dissertation = file;

  return {
    type: SET_DISSERTATION_FILE,
    file,
  };
};



// WEBPACK FOOTER //
// ./src/file-upload/fileUploadActions.js